<template>
	<div class="order-list">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h3>Export Orders</h3>

		<div class="radioCheck" v-if="selectedBrand !== null">
			<b-radio v-model="type" name="name" native-value="detail">Detail</b-radio>
			<b-radio v-model="type" name="name" native-value="summery">Summery</b-radio>
		</div>
		<br />

		<div class="orderExportSearch">
			<div v-if="staffs">
				<b-autocomplete
					v-model="staffSuggestions"
					:data="filteredStaffs"
					:open-on-focus="true"
					placeholder="Sales Person (Optional)"
					field="name"
					:disabled="selectedBrand ? true : false"
					@select="option => (selectedStaff = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div v-if="brands">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand (Optional)"
					field="name"
					:disabled="selectedStaff ? true : false"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div>
				<b-datepicker v-model="fromDate" :date-formatter="dateFormatter" placeholder="Starting Date" icon="calendar-today"
					><button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</div>

			<div>
				<b-datepicker
					v-model="toDate"
					:date-formatter="dateFormatter"
					:min-date="minDate"
					:max-date="maxDate"
					placeholder="Ending Date"
					icon="calendar-today"
				>
				</b-datepicker>
			</div>
		</div>

		<div class="export-button-wrapper">
			<div @click="exportOrders()" class="search-button">
				Export Orders
			</div>

			<div @click="exportMemberRewards()" class="search-button">
				Export Member Rewards
			</div>
			<!-- <div class="deleteIcon">
				<span @click="clearSearch">
					<ios-close-icon w="40px" h="40px" />
				</span>
			</div> -->
		</div>

		<div v-if="progress > 0" class="progress-bar">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'OrderExport',
	components: {},
	data: function() {
		return {
			isLoading: false,
			salesperson: null,
			limit: 500,
			fromDate: null,
			toDate: null,
			minDate: null,
			maxDate: null,
			pageCount: 0,
			orders: [],
			orderDetails: [],
			brands: [],
			selectedBrand: null,
			brandSuggestions: '',
			staffs: [],
			selectedStaff: null,
			staffSuggestions: '',
			progress: 0,
			type: 'detail'
		}
	},

	watch: {
		fromDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.toDate = data
			} else {
				this.toDate = null
			}
		}
	},

	mounted: async function() {
		await this.getBrands()

		await this.getStaffs()
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredStaffs() {
			return this.staffs.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.staffSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		clearSearch: function() {
			this.isLoading = false
			this.orders = []
			this.orderDetails = []
			this.selectedBrand = null
			this.brandSuggestions = ''
			this.fromDate = null
			this.toDate = null
		},

		// For calender format
		dateFormatter(dt) {
			// return dt.toLocaleDateString('en-GB')
			return this.$moment(dt).format('DD/MM/YY')
		},

		getBrands: async function() {
			const brands = await this.$api.getBrandList()

			if (brands) {
				this.brands = brands.data.list
			}
		},

		getStaffs: async function() {
			const data = {
				roles: ['salesperson'],
				limit: 1000
			}
			const staffs = await this.$api.getStaffs({ data })

			if (staffs) {
				this.staffs = staffs.data.list
			}
		},

		exportMemberRewards: async function() {
			if (this.fromDate == null || this.toDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true
			this.rewards = []
			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.fromDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.endingDate !== null) {
				createdAt['$lte'] = this.$moment(this.toDate)
					.set({ hour: 24 })
					.format('x')
			}

			// For getting total value of sales
			data = {
				populate: ['member', 'shop', 'reward', 'product'],
				time: {
					createdAt
				}
			}

			const getRewards = await this.$api.getRewardHistory({ data })

			if (getRewards.data.count < 1) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Data not found.'
				})
				this.isLoading = false
				return
			}

			let finalData = ''

			finalData += 'SHOP,REWARD,REWARD POINT,PRODUCT NAME,BD CODE,MEMBER ID,QUANTITY,DATE AND TIME\r\n'

			// total_products.map(p => {
			for (const rewardData in getRewards.data.list) {
				const reward = getRewards.data.list[rewardData]

				const shop = reward.shop
				const rewardDetail = reward.reward
				const member = reward.member
				const product = reward.product

				const toAdd = [
					shop.shop_id,
					rewardDetail.name,
					rewardDetail.points,
					'"' + product.name + '"',
					product.bd_code,
					member.card_number,
					1,
					this.convertTime(reward.createdAt)
				]

				let row = toAdd.join(',')

				finalData += row + '\r\n'
			}

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Member_Rewards.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()
		},

		// Get orders by default
		exportOrders: async function() {
			if (this.fromDate == null || this.toDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Date',
					text: 'Date fields are required!'
				})

				return
			}

			this.isLoading = true
			this.orders = []
			this.orderDetails = []
			this.progress = 0
			// Set required data
			const getOrders = await this.getOrders()

			if (getOrders !== undefined) {
				getOrders.list.map(order => {
					this.orders.push(order)
				})
			}

			// Calculate page count for pager
			this.pageCount = getOrders.total / this.limit

			if (!Number.isInteger(this.pageCount)) {
				this.pageCount = Math.ceil(this.pageCount)
			}

			const totalPages = this.pageCount

			// Get all the orders with pager
			if (totalPages > 1) {
				var i = 2

				while (i <= totalPages) {
					const skip = (i - 1) * this.limit

					const getOrders = await this.getOrders(skip)

					if (getOrders !== undefined) {
						getOrders.list.map(order => {
							this.orders.push(order)
						})
					}

					i++
				}
			}

			if (this.orders.length > 0) {
				if (!this.selectedBrand) {
					if (this.selectedStaff) {
						this.exportStaffSales()
					} else {
						this.exportAll()
					}
				} else {
					this.brandExport()
				}
			} else {
				this.$swal.fire({
					icon: 'info',
					title: 'No Data...',
					text: 'Sorry, no data found'
				})

				this.isLoading = false
			}
		},

		brandExportSummery: async function() {
			var matchProducts = {}
			let foundMatch = false
			let count = 0

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					var orderDetail = await this.$api.orderDetails(order._id)

					count++

					this.progress = (count / this.orders.length) * 100

					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							if (item.product.brand == this.selectedBrand._id) {
								foundMatch = true
								// Search brand from state
								const matchedBrand = this.brands.filter(brand => {
									return brand._id == item.product.brand
								})

								if (!matchProducts[item.product.bd_code]) {
									matchProducts[item.product.bd_code] = {
										bd_code: item.product.bd_code,
										name: item.product.name,
										brand_name: matchedBrand[0].name,
										brand_code: matchedBrand[0].code,
										barcode: item.product.barcode,
										price: item.product.price,
										qty: item.qty,
										foc: 0
									}
								} else {
									let qty = matchProducts[item.product.bd_code].qty + item.qty

									matchProducts[item.product.bd_code].qty = qty
								}
							}

							// For buy 1 get 1 items
							const itemPromotions = item.promotions
							if (itemPromotions && itemPromotions.length > 0 && itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list') {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										if (focData) {
											if (this.selectedBrand._id == focData.brand._id) {
												foundMatch = true
												if (!matchProducts[focData.bd_code]) {
													matchProducts[focData.bd_code] = {
														bd_code: focData.bd_code,
														name: focData.name,
														brand_name: focData.brand.name,
														brand_code: focData.brand.code,
														barcode: focData.barcode,
														price: focData.price ? focData.price : 0,
														qty: 0,
														foc: 1
													}
												} else {
													let foc = matchProducts[focData.bd_code].foc + 1

													matchProducts[focData.bd_code].foc = foc
												}
											}
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_foc__from_product_list' ||
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand' ||
										orderPromo.type == 'discount_order_buy_two_get_one'
									) {
										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											// Make sure brand is correct
											if (orderFocData.brand._id == this.selectedBrand._id) {
												if (orderFocData) {
													if (!matchProducts[orderFocData.bd_code]) {
														matchProducts[orderFocData.bd_code] = {
															bd_code: orderFocData.bd_code,
															name: orderFocData.name,
															brand_name: orderFocData.brand.name,
															brand_code: orderFocData.brand.code,
															barcode: orderFocData.barcode,
															price: orderFocData.price ? orderFocData.price : 0,
															qty: 0,
															foc: 1
														}
													} else {
														let foc = matchProducts[orderFocData.bd_code].foc + 1

														matchProducts[orderFocData.bd_code].foc = foc
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}

			let csv = 'BD CODE,PRODUCT NAME,BRAND NAME,BRAND CODE,BARCODE,PRICE,QUANTITY,FOC\r\n'

			// Transform objects into array
			for (let products in matchProducts) {
				let product = matchProducts[products]

				const toAdd = [
					product.bd_code,
					'"' + product.name + '"',
					'"' + product.brand_name + '"',
					product.brand_code,
					'"' + product.barcode + '"',
					product.price,
					product.qty,
					product.foc
				]

				let row = toAdd.join(',')

				csv += row + '\r\n'
			}

			if (!foundMatch) {
				this.$swal.fire('Nothing found!', 'Nothing found!', 'info')
				this.isLoading = false
				return
			}

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', this.selectedBrand.code + '_summery.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		brandExport: async function() {
			if (this.type == 'summery') {
				this.brandExportSummery()

				return
			}

			let foundMatch = false

			let csv = ''
			csv += 'DATE,TIME,ORDER ID,BD CODE,BRAND NAME,BRAND CODE,PRODUCT NAME,BARCODE,PRICE,DISCOUNT,SPECIAL DISCOUNT,PACKAGING,QUANTITY,NET AMOUNT\r\n'

			let count = 0

			if (this.orders.length > 0) {
				for (let order of this.orders) {
					var orderDetail = await this.$api.orderDetails(order._id)

					count++

					this.progress = (count / this.orders.length) * 100

					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							// console.log(item)

							// Search brand from state
							const matchedBrand = this.brands.filter(brand => {
								return brand._id == item.product.brand
							})

							if (this.selectedBrand._id == item.product.brand) {
								foundMatch = true

								const toAdd = [
									this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
									this.$moment(order.updatedAt).format('HH:mm'), // Time
									order.alias, // Order ID
									item.product.bd_code, // BD Code
									matchedBrand[0].name, // Brand Name
									matchedBrand[0].code, // Brand Code
									'"' + item.product.name + '"', // Product Name
									item.product.barcode, // Barcode
									item.product.price, // Price
									this.calculateDiscount(item) ? this.calculateDiscount(item) : '0', // Discount Amount
									item.special_discount_percent ? item.special_discount_percent : '0', // Special Discount
									item.package && item.package.packaging_selection ? item.package.packaging_selection : 'single_item', // Packaging
									item.qty, // Quantity
									item.total_price // Net Amount
								]

								let row = toAdd.join(',')

								csv += row + '\r\n'
							}

							// For buy 1 get 1 items
							const itemPromotions = item.promotions
							if (itemPromotions && itemPromotions.length > 0 && itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list') {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										if (focData) {
											if (this.selectedBrand._id == focData.brand._id) {
												foundMatch = true

												const focToAdd = [
													this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
													this.$moment(order.updatedAt).format('HH:mm'), // Time
													order.alias, // Order ID
													focData.bd_code, // BD Code
													focData.brand.name, // Brand Name
													focData.brand.code, // Brand Code
													'"' + focData.name + '"', // Product Name
													focData.barcode, // Barcode
													'0', // Price
													'0', // Discount Amount
													'0', // Special Discount
													'single_item', // Packaging (FOC items default to single_item)
													'1', // Quantity
													'0'
												] // Net Amount

												let focRow = focToAdd.join(',')

												csv += focRow + '\r\n'
											}
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_foc__from_product_list' ||
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand' ||
										orderPromo.type == 'discount_order_buy_two_get_one'
									) {
										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											if (orderFocData) {
												if (this.selectedBrand._id == orderFocData.brand._id) {
													foundMatch = true

													const focToAdd = [
														this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
														this.$moment(order.updatedAt).format('HH:mm'), // Time
														order.alias, // Order ID
														orderFocData.bd_code, // BD Code
														orderFocData.brand.name, // Brand Name
														orderFocData.brand.code, // Brand Code
														'"' + orderFocData.name + '"', // Product Name
														orderFocData.barcode, // Barcode
														'0', // Price
														'0', // Discount Amount
														'0', // Special Discount
														'single_item', // Packaging (FOC items default to single_item)
														'1', // Quantity
														'0'
													] // Net Amount

													let orderFocRow = focToAdd.join(',')

													csv += orderFocRow + '\r\n'
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}

			if (!foundMatch) {
				this.$swal.fire('Nothing found!', 'Nothing found!', 'info')
				this.isLoading = false
				return
			}

			const todayDate = this.$moment(this.date).format('DD-MM-YY')

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', this.selectedBrand.code + '-' + todayDate + '-orders.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		exportStaffSales: async function() {
			let csv = ''
			let total = 0

			csv += 'DATE,TIME,SALES PERSON,SALES PERSON ID,ORDER ID,ORDER TOTAL\r\n'
			// Make sure orders are not blank
			if (this.orders.length > 0) {
				for (const order of this.orders) {
					const toAdd = [
						this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
						this.$moment(order.updatedAt).format('HH:mm'), // Time
						order.salesperson.name,
						order.salesperson.username,
						order.alias, // Order ID
						order.total_price
					]

					total += order.total_price

					let row = toAdd.join(',')

					csv += row + '\r\n'
				}
			}

			csv += '=,=,=,=,=,=' + '\r\n'
			csv += ',,,,OVERALL TOTAL,' + total + '\r\n'
			csv += '=,=,=,=,=,=' + '\r\n'

			const todayDate = this.$moment(this.date).format('DD-MM-YY')

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', this.selectedStaff.name + ' ' + todayDate + '-orders.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		exportAll: async function() {
			let csv = ''
			let total = 0
			let count = 0

			csv +=
				'DATE,TIME,ORDER ID,BD CODE,BRAND NAME,BRAND CODE,PRODUCT NAME,BARCODE,PRICE,DISCOUNT,SPECIAL DISCOUNT,PACKAGING,QUANTITY,FOC QUANTITY,NET AMOUNT,ONLINE SALES\r\n'
			// Make sure orders are not blank
			if (this.orders.length > 0) {
				// Loop every order
				for (let order of this.orders) {
					// Get order details of each order
					var orderDetail = await this.$api.orderDetails(order._id)

					count++

					this.progress = (count / this.orders.length) * 100

					// If API Call was fine, continue
					if (orderDetail !== undefined) {
						for (let item of orderDetail.data.items) {
							// Search brand from state
							const matchedBrand = this.brands.filter(brand => {
								return brand._id == item.product.brand
							})

							let onlineSalesBrand

							if (orderDetail.data.online_sales) {
								// Search brand from state
								onlineSalesBrand = this.brands.find(brand => {
									return brand._id == orderDetail.data.online_sales
								})
							}

							console.log(item)

							// To add main products into CSV
							const toAdd = [
								this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
								this.$moment(order.updatedAt).format('HH:mm'), // Time
								order.alias, // Order ID
								item.product.bd_code, // BD Code
								matchedBrand.length > 0 ? matchedBrand[0].name : '', // Brand Name
								matchedBrand.length > 0 ? matchedBrand[0].code : '', // Brand Code
								'"' + item.product.name + '"', // Product Name
								item.product.barcode, // Barcode
								item.product.price, // Price
								this.calculateDiscount(item) ? this.calculateDiscount(item) : '0', // Discount Amount
								item.special_discount_percent ? item.special_discount_percent : '0', // Special Discount
								item.product.packaging_selection ? item.product.packaging_selection : 'single_item', // Packaging
								item.qty, // Quantity
								'',
								item.total_price, // Net Amount
								onlineSalesBrand ? onlineSalesBrand.name : ''
							]

							let row = toAdd.join(',')

							csv += row + '\r\n'

							// For buy 1 get 1 items
							const itemPromotions = item.promotions
							if (
								itemPromotions &&
								itemPromotions.length > 0 &&
								(itemPromotions[0].type == 'discount_product_buy_and_get_foc_from_list' ||
									itemPromotions[0].type == 'discount_product_buy_one_get_one_and_percentage')
							) {
								if (itemPromotions[0].options && itemPromotions[0].options.products && itemPromotions[0].options.products.length > 0) {
									for (let focItem of itemPromotions[0].options.products) {
										const focData = await this.getProductDetail(focItem)

										// if (this.exportType == "all") {
										if (focData) {
											const focToAdd = [
												this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
												this.$moment(order.updatedAt).format('HH:mm'), // Time
												order.alias, // Order ID
												focData.bd_code, // BD Code
												focData.brand.name, // Brand Name
												focData.brand.code, // Brand Code
												'"' + focData.name + '"', // Product Name
												focData.barcode, // Barcode
												'0', // Price
												'0', // Discount Amount
												'0', // Special Discount
												'single_item', // Packaging (FOC items default to single_item)
												'0', // Quantity
												'1', // FOC Quantity
												'0', // Net Amount
												onlineSalesBrand ? onlineSalesBrand.name : ''
											]

											let focRow = focToAdd.join(',')

											csv += focRow + '\r\n'
										}
									}
								}
							}
						}

						// For Order FOC and Brand FOC
						if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
							for (let orderPromo of orderDetail.data.promotions) {
								if (orderPromo.options && orderPromo.options.products && orderPromo.options.products.length > 0) {
									if (
										orderPromo.type == 'discount_order_foc__from_product_list' ||
										orderPromo.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand' ||
										orderPromo.type == 'discount_order_buy_two_get_one'
									) {
										for (let orderFocItem of orderPromo.options.products) {
											const orderFocData = await this.getProductDetail(orderFocItem)

											let onlineSalesBrand

											if (orderDetail.data.online_sales) {
												// Search brand from state
												onlineSalesBrand = this.brands.find(brand => {
													return brand._id == orderDetail.data.online_sales
												})
											}

											if (orderFocData) {
												const focToAdd = [
													this.$moment(order.updatedAt).format('DD/MM/YYYY'), // Date
													this.$moment(order.updatedAt).format('HH:mm'), // Time
													order.alias, // Order ID
													orderFocData.bd_code, // BD Code
													orderFocData.brand.name, // Brand Name
													orderFocData.brand.code, // Brand Code
													'"' + orderFocData.name + '"', // Product Name
													orderFocData.barcode, // Barcode
													'0', // Price
													'0', // Discount Amount
													'0', // Special Discount
													'single_item', // Packaging (FOC items default to single_item)
													'0', // Quantity
													'1', // FOC Quantity
													'0', // Net Amount
													onlineSalesBrand ? onlineSalesBrand.name : ''
												]

												let orderFocRow = focToAdd.join(',')

												csv += orderFocRow + '\r\n'
											}
										}
									}
								}
							}
						}

						// Add remarks
						if (orderDetail.data.description) {
							csv += ',,,,,,,,,,,,REMARKS,"' + orderDetail.data.description + '"\r\n'
						}
						// Add coupons
						if (order.coupons && order.coupons.length > 0) {
							csv += ',,,,,,,,,,,COUPONS' + '\r\n'

							for (let coupon of order.coupons) {
								const matchedBrand = this.brands.filter(brand => {
									return brand._id == coupon.brand
								})

								csv += ',,,,,,,,,,,' + matchedBrand[0].name + ',' + matchedBrand[0].code + ',' + coupon.amount + '\r\n'
							}

							csv += '\r\n'
						}

						// To filter out zero payment checkouts
						if (orderDetail.data.items && orderDetail.data.items.length > 0) {
							csv += ',,,,,,,,,,,,,Total,' + order.total_price + '\r\n'
							csv += '\r\n'
						}

						// Add total sales for selected date
						total += order.total_price
					}
				}

				csv += '=,=,=,=,=,=,=,=,=,=,=,=,=,=' + '\r\n'
				csv += ',,,,,,,,,,,,,OVERALL TOTAL,' + total + '\r\n'
				csv += '=,=,=,=,=,=,=,=,=,=,=,=,=,=' + '\r\n'
			}

			const todayDate = this.$moment(this.date).format('DD-MM-YY')

			var csvData = new Blob([csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', todayDate + '-orders.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()

			this.isLoading = false
		},

		// Get product detail
		getProductDetail: async function(product_id) {
			const data = {
				id: product_id,
				populate: ['brand']
			}

			const getFocProduct = await this.$api.getProductDetail({
				data
			})

			if (getFocProduct !== undefined) {
				return getFocProduct.data
			} else {
				return
			}
		},

		// To calculate the discount
		calculateDiscount: function(item) {
			if (item.promotions && item.promotions.length > 0) {
				// For 2 percentage discounts
				if (item.promotions[0].type == 'discount_product_percentage_by_brands' || item.promotions[0].type == 'discount_product_percentage') {
					return (item.product.price * item.promotions[0].condition.percentage) / 100
				} else if (item.promotions[0].type == 'discount_product_price') {
					// For fixed price discount (price point)
					return item.promotions[0].condition.price
				}
			} else if (item.special_discount_percent !== 0) {
				// For special discount
				return (item.product.price * item.special_discount_percent) / 100
			}
		},

		// Generate CSV file
		generateCSV: function() {
			let export_csv = 'ORDER ID,BD CODE,PRODUCT NAME,BRAND CODE,BRAND NAME,QTY,AMOUNT,DATE,DESCRIPTION\r\n'

			// Map all the PI products
			if (this.orderDetails && this.orderDetails.length > 0) {
				this.orderDetails.map(item => {
					// console.log(item)

					const brand = this.brands.find(brand => {
						return item.product.brand == brand._id
					})

					const toAdd = [
						item.order_id,
						item.product.bd_code,
						'"' + item.product.name + '"',
						brand.code,
						brand.name,
						item.qty,
						item.total_price,
						this.$moment(item.updatedAt).format('DD/MM/YY HH:mm'),
						item.description
					]

					let row = toAdd.join(',')

					export_csv += row + '\r\n'
				})

				const todayDate = this.$moment(this.date).format('DD-MM-YY')

				var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
				var csvUrl = URL.createObjectURL(csvData)

				var link = document.createElement('a')
				link.setAttribute('href', csvUrl)
				link.setAttribute('download', todayDate + '-orders.csv')
				document.body.appendChild(link) // Required for FF

				link.click()
				link.remove()
			}

			this.isLoading = false
		},

		// Search by Order ID
		getOrders: async function(skip = 0) {
			var data = {
				skip,
				// populate: ['salesperson', 'cashier'],
				limit: this.limit,
				pay_status: 1,
				time: {
					createdAt: {
						$gte: this.$moment(this.fromDate)
							.set({ hour: 0 })
							.format('x'),
						$lte: this.$moment(this.toDate)
							.set({ hour: 24 })
							.format('x')
					}
				},
				sort: {
					createdAt: 'asc',
					_id: 'asc'
				}
			}

			if (this.selectedStaff) {
				data.salesperson = this.selectedStaff._id
				data.populate = ['salesperson']
			}

			// Get total orders
			const orders = await this.$api.orderList({ data })

			return orders.data
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YYYY hh:mm A')
		}
	}
}
</script>

<style scoped>
@import '../styles/OrderList.css';
</style>
